import { preloadLazyMedia } from "../utils/lazy-media";

/**
 * Infinite horizontal panning carousel for about page
 */
export function initAboutCarousel() {
  const carousel = document.querySelector('.c-about-carousel');
  if (!carousel) return;
  
  const track = carousel.querySelector('.c-about-carousel__track');
  if (!track) return;
  
  // Check if already initialized
  if (track.dataset.initialized === 'true') return;
  
  const items = track.querySelectorAll('figure');
  if (items.length === 0) return;
  
  // Force-load all images up front (track may extend past viewport).
  preloadLazyMedia(track);

  // Initialize carousel immediately - don't wait for images
  initializeCarousel();
  
  function initializeCarousel() {
    // Clone all items to create seamless infinite loop
    const clonedItems = Array.from(items).map(item => item.cloneNode(true));
    clonedItems.forEach(item => {
      track.appendChild(item);
    });
    
    preloadLazyMedia(track);

    // Set animation speed (lower = faster)
    const speed = 90; // seconds to complete one cycle (50% of content)
    track.style.setProperty('--carousel-speed', `${speed}s`);
    
    // Start animation
    track.classList.add('is-animating');
    track.dataset.initialized = 'true';
    
    // Ensure images maintain aspect ratio with fixed height
    const allImages = track.querySelectorAll('.o-image');
    allImages.forEach(img => {
      img.style.height = '100%';
      img.style.width = 'auto';
      img.style.objectFit = 'contain';
    });
  }
}

